import React from 'react'
import { Button, Dialog, DialogActions } from '@mui/material'
import { BsBank2 } from "react-icons/bs";
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';  
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../redux/actions/message';
import { getVisibleFormInputs } from '../../../helpers/base';

const IbvDialog = ({
  open,
  handleClose,
  handleOpen: setOpen,
  requestWidgetURL
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleOpen = () => {
    /* const params = {
      pendingVerification: true
    }
    dispatch(setIBV(params)) */
    const form = document.getElementsByTagName('Form')[0];
    const visibleInputs = getVisibleFormInputs(form)
    const isFormPopulated = visibleInputs?.length > 0;
    
    if (!isFormPopulated) {
      setOpen(true) // Open IBV if form has no inputs
    } else {
      dispatch(setMessage(t('ibv.formRequired'), 'info')) // Prompt user for form completition
    }

  } 

  return (
    <>
      <Alert variant={'warning'}>
        <Button variant="text" startIcon={<BsBank2 />} onClick={handleOpen}>
          {t("ibv.ibv")}
        </Button>
      </Alert>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        fullScreen={fullScreen}
      >

        {
          (requestWidgetURL?.length > 0) ? (
          <div id='iframe_container'>
            <iframe id='the_iframe' title='Instant Bank Verification'>
            </iframe> 
          </div>) : (
          <>
          <div class="alert alert-primary" role="alert">
            {t('ibv.notAvailable')}
          </div>
          </>)
        }
    
        <DialogActions>
          <Button onClick={handleClose}>
            {t("common.cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default IbvDialog